import { createRouter, createWebHistory } from "vue-router";
import {
  checkRole,
  doesUserRoleHave,
  errorToast,
  getEntityQuery,
  lowerCase,
  subEntity,
  translateText,
  userInSession,
} from "@/core/helpers/utility";
import routesConfig from "@/core/helpers/RouteList/routes";
const routes = [
  //Authentication
  {
    path: "/",
    redirect: "/Login",
  },
  {
    path: "/Login",
    name: "login",
    meta: {
      title: "Login",
    },
    component: () => import("@/views/Auth/Login.vue"),
  },
  {
    path: "/resolver-login",
    name: "resolver-login",
    meta: {
      title: "Resolver Login",
    },
    component: () => import("@/views/Auth/resolverLogin.vue"),
  },
  {
    path: "/forgot-password",
    name: "forgot-password",
    meta: {
      title: "Forgot Password",
    },
    component: () => import("@/views/Auth/forgotPassword.vue"),
  },
  {
    path: "/Account/ResetPassword",
    name: "reset-password",
    meta: {
      title: "Reset Password",
    },
    component: () => import("@/views/Auth/resetPassword.vue"),
  },
  {
    path: "/contact",
    name: "contact",
    meta: {
      title: "Contact Us",
    },
    component: () => import("@/views/Auth/contact.vue"),
  },
  {
    path: "/account/confirmEmail",
    name: "confirm-email",
    meta: {
      title: "Confirm Email",
    },
    component: () => import("@/views/Auth/confirmEmail.vue"),
  },
  {
    path: "/vendorapprovalcheck",
    name: "confirm-vendor",
    meta: {
      title: "Confirm Vendor",
    },
    component: () => import("@/views/Auth/confirmVendor.vue"),
  },
  {
    path: "/call-back",
    name: "callback",
    meta: {
      title: "Callback",
    },
    component: () => import("@/views/Auth/callBack.vue"),
  },
  // Components
  {
    path: "/component",
    name: "component",
    meta: {
      title: "Components",
    },
    component: () => import("@/views/componentView/componentView.vue"),
  },
  {
    path: "/settings",
    name: "settings",
    meta: {
      title: "Settings",
      middleware: "auth",
    },
    component: () => import("@/views/Common/Settings/index.vue"),
  },

  ////////////////// STATION LEVEL ROUTES
  /////////////// REPORTS
  //////////////// SALES REPORTS
  {
    path: "/station/sales-transactions",
    name: "station-sales-transactions",
    meta: {
      title: "Sales Transactions",
      middleware: "auth",
    },
    component: () =>
      import("@/views/Branch/Reports/SalesReports/SalesTransactions/index.vue"),
  },
  {
    path: "/station/end-of-day-report",
    name: "station-end-of-day-report",
    meta: {
      title: "End of Day Report",
      middleware: "auth",
    },
    component: () =>
      import("@/views/Branch/Reports/SalesReports/EndOfDayReport.vue"),
  },
  {
    path: "/station/pump-variance",
    name: "station-pump-variance",
    meta: {
      title: "Pump Variance",
      middleware: "auth",
    },
    component: () =>
      import("@/views/Branch/Reports/SalesReports/PumpVariance.vue"),
  },
  {
    path: "/station/tank-variance",
    name: "station-tank-variance",
    meta: {
      title: "Tank Variance",
      middleware: "auth",
    },
    component: () =>
      import("@/views/Branch/Reports/SalesReports/TankVariance.vue"),
  },
  {
    path: "/station-pos-sales",
    name: "station-pos-sales",
    meta: {
      title: "POS Sales",
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/Reports/SalesReports/POSSales.vue"),
  },
  {
    path: "/branch-sufficiency-metrics",
    name: "branch-sufficiency-metrics",
    meta: {
      title: "Branch Sufficiency Metrics",
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/Reports/InventoryReports/SufficiencyMetrics/branchSufficiency.vue"),
  },

  //////////////// CASH REPORTS
  {
    path: "/station/cashflow",
    name: "station-cashflow",
    meta: {
      title: "Cashflow Report",
      middleware: "auth",
    },
    component: () => import("@/views/Branch/Reports/CashReports/Cashflow.vue"),
  },

  //////////////// INVENTORY REPORTS
  {
    path: "/station/sales-transactions",
    name: "station-sales-transactions",
    meta: {
      title: "Sales Transactions",
      middleware: "auth",
    },
    component: () =>
      import("@/views/Branch/Reports/SalesReports/SalesTransactions/index.vue"),
  },

  // 🚨 Company Level

  {
    path: "/equipment-report",
    name: "equipment-report",
    meta: {
      title: "Equipment report",
      middleware: "auth",
    },
    component: () => import("@/views/Company/EquipmentReport/index.vue"),
  },
  {
    path: "/station-missing-data",
    name: "station-missing-data",
    meta: {
      title: "Station Missing Data",
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/EquipmentReport/StationMissingData.vue"),
  },

    {
    path: "/equipment-breakdown",
    name: "equipment-breakdown",
    meta: {
      title: "Equipment Breakdown",
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/EquipmentReport/EquipmentBreakdown.vue"),
  },

  {
    path: "/all-equipments",
    name: "all-equipments",
    meta: {
      title: "All Equipments",
      middleware: "auth",
    },
    component: () => import("@/views/Company/EquipmentReport/AllEquipments.vue"),
  },
  // Dashboards
  {
    path: "/dashboard",
    name: "dashboard",
    meta: {
      title: "Dashboard",
      middleware: "auth",
    },
    component: () => import("@/views/Common/Dashboard/index.vue"),
  },

  // staff Dashboard
  {
    path: "/staff-dashboard",
    name: "staff-dashboard",
    meta: {
      title: "Staff Dashboard",
      middleware: "auth",
    },

    component: () => import("@/views/Company/Dashboards/StaffMgt.vue"),
  },

  // Maintenance Dashboard
  {
    path: "/maintenance-dashboard",
    name: "maintenance-dashboard",
    meta: {
      title: "Maintenance Dashboard",
      middleware: "auth",
    },

    component: () =>
      import("@/views/Company/Dashboards/MaintenanceDashboard.vue"),
  },

  // Drystock Dashboard
  {
    path: "/drystock-dashboard",
    name: "drystock-dashboard",
    meta: {
      title: "Drystock Dashboard",
      middleware: "auth",
    },

    component: () => import("@/views/Company/Dashboards/DrystockDashboard.vue"),
  },

  // Property Mnagement Dashboard
  {
    path: "/property-dashboard",
    name: "property-dashboard",
    meta: {
      title: "Property Dashboard",
      middleware: "auth",
    },

    component: () =>
      import("@/views/Company/Dashboards/PropertyMgtDashboard.vue"),
  },

  // Remis Dashboard
  {
    path: "/remis-dashboard",
    name: "remis-dashboard",
    meta: {
      title: "Remis Dashboard",
      middleware: "auth",
    },

    component: () => import("@/views/Company/Dashboards/RemisDashboard.vue"),
  },

  {
    path: "/remis-transactions",
    name: "remis-transactions",
    meta: {
      title: "Remis Transaction",
      middleware: "auth",
    },

    component: () => import("@/views/Branch/Remis/RemisTransaction.vue"),
  },

  // NNPC ROUTE
  {
    path: "/company-product-stock",
    name: "company-product-stock",
    meta: {
      title: "Product Stock",
      middleware: "auth",
    },
    component: () => import("@/views/Company/NNPC/ProductStock.vue"),
  },
  {
    path: "/company-product-inventory",
    name: "company-product-inventory",
    meta: {
      title: "Product Inventory",
      middleware: "auth",
    },
    component: () => import("@/views/Company/NNPC/ProductInventory.vue"),
  },
  {
    path: "/inventory-supply/:branchId",
    name: "inventory-supply",
    meta: {
      title: "Inventory Supply",
      middleware: "auth",
    },
    component: () => import("@/views/Company/NNPC/InventorySupply.vue"),
  },
  {
    path: "/inventory-sales/:branchId",
    name: "inventory-sales",
    meta: {
      title: "Inventory Sales",
      middleware: "auth",
    },
    component: () => import("@/views/Company/NNPC/InventorySales.vue"),
  },

  // Dashboard Summary Pages
  {
    path: "/disconnected-pumps",
    name: "disconnected-pumps",
    meta: {
      title: "Disconnected Pumps",
      middleware: "auth",
    },
    component: () =>
      import("@/views/Common/Dashboard/SummaryPages/DisconnectedPumps.vue"),
  },
  {
    path: "/offline-pumps",
    name: "offline-pumps",
    meta: {
      title: "Offline Pumps",
      middleware: "auth",
    },
    component: () =>
      import("@/views/Common/Dashboard/SummaryPages/OfflinePumps.vue"),
  },
  {
    path: "/transaction-count",
    name: "transaction-count",
    meta: {
      title: "Transaction Count",
      middleware: "auth",
    },
    component: () =>
      import("@/views/Common/Dashboard/SummaryPages/TransactionCount.vue"),
  },

  // Stations
  {
    path: "/stations",
    name: "stations",
    meta: {
      title: "Stations",
      middleware: "auth",
    },
    component: () => import("@/views/Company/Stations/index.vue"),
  },
  {
    path: "/station-dashboard",
    name: "station-dashboard",
    meta: {
      title: "Station Dashboard",
      middleware: "auth",
    },
    component: () => import("@/views/Company/Stations/StationDashboard.vue"),
  },
  {
    path: "/mail-recepient/:id",
    name: "mail-recepient",
    meta: {
      title: "Mail Recipients",
      middleware: "auth",
    },
    component: () => import("@/views/Company/Stations/MailRecepient.vue"),
  },
  {
    path: "/monthly-budget/:id",
    name: "monthly-budget",
    meta: {
      title: "Monthly Budget",
      middleware: "auth",
    },
    component: () => import("@/views/Company/Stations/MonthlyBudget.vue"),
  },
  {
    path: "/max-cash-amount/:id",
    name: "max-cash-amount",
    meta: {
      title: "Max Cash Amount",
      middleware: "auth",
    },
    component: () => import("@/views/Company/Stations/MaxCashAmount.vue"),
  },
  {
    path: "/manage-target",
    name: "manage-target",
    meta: {
      title: "Manage Targets",
      middleware: "auth",
    },
    component: () => import("@/views/Common/ManageTarget/ManageTarget.vue"),
  },

  ///////////////// REPORTS
  // Station Sales
  {
    path: "/station-sales",
    name: "station-sales",
    meta: {
      title: "Station Sales",
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/Reports/SalesReports/StationSales.vue"),
  },

  {
    path: "/retainership-sales",
    name: "retainership-sales",
    meta: {
      title: "Retainership Sales",
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/Reports/SalesReports/RetainershipSales/index.vue"),
  },

  {
    path: "/retainership-sales-details",
    name: "retainership-sales-details",
    meta: {
      title: "Retainership Sales Details",
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/Reports/SalesReports/RetainershipSales/details.vue"),
  },
  {
    path: "/tank-variance",
    name: "tank-variance",
    meta: {
      title: "Tank Variance",
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/Reports/SalesReports/TankVariance.vue"),
  },
  {
    path: "/pump-variance",
    name: "pump-variance",
    meta: {
      title: "Pump Variance",
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/Reports/SalesReports/PumpVariance.vue"),
  },
  {
    path: "/remis-sales",
    name: "remis-sales",
    meta: {
      title: "REMIS Sales",
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/Reports/SalesReports/RemisSales/index.vue"),
  },
  {
    path: "/remis-sales-details",
    name: "remis-sales-details",
    meta: {
      title: "REMIS Sales Details",
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/Reports/SalesReports/RemisSales/Details.vue"),
  },
  {
    path: "/remis-company-wallet",
    name: "remis-company-wallet",
    meta: {
      title: "REMIS Company Wallet",
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/Reports/SalesReports/RemisSales/CompanyWallet.vue"),
  },
  {
    path: "/remis-sales-wallet",
    name: "remis-sales-wallet",
    meta: {
      title: "REMIS Sales Wallet",
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/Reports/SalesReports/RemisSales/RemisWallet.vue"),
  },
  {
    path: "/pos-sales",
    name: "pos-sales",
    meta: {
      title: "POS Sales",
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/Reports/SalesReports/POSSales.vue"),
  },
  {
    path: "/cashflow",
    name: "cashflow",
    meta: {
      title: "Cashflow",
      middleware: "auth",
    },
    component: () => import("@/views/Company/Reports/CashReports/Cashflow.vue"),
  },
  {
    path: "/daily-branch-transactions",
    name: "daily-branch-transactions",
    meta: {
      title: "Daily Branch Transactions",
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/Reports/CashReports/DailyBranchTranactions.vue"),
  },

  // Inventory Report
  {
    path: "/product-discharged",
    name: "product-discharged",
    meta: {
      title: "Product Discharged",
      middleware: "auth",
      isEntityDependent: true,
      companyComponent: () =>
        import("@/views/Company/Reports/InventoryReports/ProductDischarged/index.vue"),
      branchComponent: () =>
        import("@/views/Branch/Reports/InventoryReports/ProductsDischarged.vue"),
    },
  },
  {
    path: "/tank-daily-report/:id",
    name: "tank-daily-report",
    meta: {
      title: "Tank Daily Report",
      middleware: "auth",
    },
    component: () => import("@/views/Company/TankManagement/dailyReport.vue"),
  },
  {
    path: "/check-calibration/:id",
    name: "check-calibration",
    meta: {
      title: "Check Calibration",
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/TankManagement/checkCalibration.vue"),
  },
  {
    path: "/discharged-details/:id",
    name: "discharged-details",
    meta: {
      title: "Discharge Details",
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/Reports/InventoryReports/ProductDischarged/DischargeDetails.vue"),
  },
  {
    path: "/stock-valuation",
    name: "stock-valuation",
    meta: {
      title: "Stock Valuation",
      middleware: "auth",
      isEntityDependent: true,
      companyComponent: () =>
        import("@/views/Company/Reports/InventoryReports/StockValuation.vue"),
      branchComponent: () =>
        import("@/views/Branch/Reports/InventoryReports/StockValuation.vue"),
    },
  },
  {
    path: "/tank-report",
    name: "tank-report",
    meta: {
      title: "Tank Report",
      middleware: "auth",
    },
    component: () =>
      import("@/views/Branch/Reports/InventoryReports/TankReport.vue"),
  },
  {
    path: "/inventory-report",
    name: "Inventory-report",
    meta: {
      title: "Inventory Report",
      middleware: "auth",
    },
    component: () =>
      import("@/views/Branch/Reports/InventoryReports/InventoryReport.vue"),
  },

  {
    path: "/product-stock",
    name: "product-stock",
    meta: {
      title: "Product Stock",
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/Reports/InventoryReports/ProductStock.vue"),
  },

  {
    path: "/branch-reports",
    name: "branch-reports",
    meta: {
      title: "Branch Reports",
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/Reports/InventoryReports/BranchReports.vue"),
  },

  {
    path: "/sufficiency-metrics",
    name: "sufficiency-metrics",
    meta: {
      title: "Sufficiency Metrics",
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/Reports/InventoryReports/SufficiencyMetrics/index.vue"),
  },

  //Transactions
  {
    path: "/transactions",
    name: "transactions",
    meta: {
      title: "Transactions",
      middleware: "auth",
    },
    component: () => import("@/views/Company/Transactions/index.vue"),
  },

  //Drystock
  {
    path: "/dry-stock-product",
    name: "dry-stock-product",
    meta: {
      title: "Dry Stock Products",
      middleware: "auth",
      isEntityDependent: true,
      companyComponent: () =>
        import("@/views/Company/DryStock/Product/index.vue"),
    },
  },
  {
    path: "/dry-stock-product/:id",
    name: "drystock-single-product",
    meta: {
      title: "Dry Stock Product Details",
      middleware: "auth",
      isEntityDependent: true,
      companyComponent: () =>
        import("@/views/Company/DryStock/Product/SingleProduct.vue"),
    },
  },
  {
    path: "/branch-product-stock",
    name: "dry-stock-stock",
    meta: {
      title: "Branch Product Stock",
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/DryStock/BranchProductStock/BranchProductStock.vue"),
  },
  {
    path: "/branch-product-stock-sale/:id",
    name: "dry-stock-stock-sale",
    meta: {
      title: "Product Stock Sales",
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/DryStock/BranchProductStock/SalesDetails.vue"),
  },
  {
    path: "/branch-product-stock-supply/:id",
    name: "dry-stock-stock-supply",
    meta: {
      title: "Product Stock Supply",
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/DryStock/BranchProductStock/SupplyDetails.vue"),
  },

  {
    name: "dry-stock-supply",
    path: "/dry-stock-supply",
    meta: {
      title: "Dry Stock Supply",
      middleware: "auth",
      isEntityDependent: true,
      companyComponent: () =>
        import("@/views/Company/DryStock/supply/supply.vue"),
      branchComponent: () =>
        import("@/views/Branch/Drystock/Supply/supply.vue"),
    },
  },
  {
    name: "dry-stock-supply-details",
    path: "/dry-stock-supply-details/:id",
    meta: {
      title: "Supply Details",
      middleware: "auth",
      isEntityDependent: true,
      companyComponent: () =>
        import("@/views/Company/DryStock/supply/supplyDetail.vue"),
      branchComponent: () =>
        import("@/views/Branch/Drystock/Supply/supplyDetail.vue"),
    },
  },
  {
    path: "/dry-stock-product-cat",
    name: "dry-stock-product-cat",
    meta: {
      title: "Product Categories",
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/DryStock/productCategory/productCategory.vue"),
  },
  {
    path: "/category-details/:id",
    name: "category-details",
    meta: {
      title: "Category Details",
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/DryStock/productCategory/details.vue"),
  },
  {
    name: "dry-stock-sales",
    path: "/dry-stock-sales",
    meta: {
      title: "Dry Stock Sales",
      middleware: "auth",
      isEntityDependent: true,
      companyComponent: () =>
        import("@/views/Company/DryStock/Sales/sales.vue"),
      branchComponent: () => import("@/views/Branch/Drystock/Sales/sales.vue"),
    },
  },
  {
    name: "dry-stock-sales-details",
    path: "/dry-stock-sales-details/:id",
    meta: {
      title: "Drystock Sales Details",
      middleware: "auth",
      isEntityDependent: true,
      companyComponent: () =>
        import("@/views/Company/DryStock/Sales/SalesDetails.vue"),
      branchComponent: () =>
        import("@/views/Branch/Drystock/Sales/SalesDetails.vue"),
    },
  },

  //Region
  {
    path: "/region",
    name: "region",
    meta: {
      title: "Regions",
      middleware: "auth",
    },
    component: () => import("@/views/Company/Region/index.vue"),
  },
  {
    path: "/region-stations",
    name: "region-stations",
    meta: {
      title: "Region Stations",
      middleware: "auth",
    },
    component: () => import("@/views/Company/Region/region-stations.vue"),
  },
  //Pump management
  {
    path: "/pump-management",
    name: "pump-management",
    meta: {
      title: "Pump Management",
      middleware: "auth",
      isEntityDependent: true,
      branchComponent: () => import("@/views/Company/PumpManagement/index.vue"),
    },
  },
  {
    path: "/pump-details/:pumpId",
    name: "pump-details",
    meta: {
      title: "Pump Details",
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/PumpManagement/PumpDetails/index.vue"),
  },
  {
    path: "/manage-pump-lock",
    name: "manage-pump-lock",
    meta: {
      title: "Manage Pump Lock",
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/PumpManagement/ManagePumpLock/index.vue"),
  },

  // Price Management
  {
    path: "/price-log",
    name: "price-log",
    meta: {
      title: "Price Log",
      middleware: "auth",
      // isEntityDependent: true,
      // companyComponent: () =>
      //   import("@/views/Company/PriceManagement/PriceLog/PriceLog.vue"),
      // branchComponent: () =>
      //   import("@/views/Branch/PriceManagement/PriceLog.vue"),
    },
    component: () =>
      import("@/views/Company/PriceManagement/PriceLog/PriceLog.vue"),
  },
  {
    path: "/price-log-breakdown/:id",
    name: "price-log-breakdown",
    meta: {
      title: "Price Breakdown",
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/PriceManagement/PriceLog/Breakdown.vue"),
  },
  {
    path: "/price-approval",
    name: "price-approval",
    meta: {
      title: "Price Approval",
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/PriceManagement/priceApproval/index.vue"),
  },
  {
    path: "/manage-approval",
    name: "manage-approval",
    meta: {
      title: "Manage Approval",
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/PriceManagement/ManageApproval/index.vue"),
  },
  {
    path: "/price-approval-details",
    name: "price-approval-details",
    meta: {
      title: "Approval Details",
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/PriceManagement/priceApproval/requestDetails.vue"),
  },
  {
    path: "/pump-calibration",
    name: "pump-calibration",
    meta: {
      title: "Pump Calibration",
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/PriceManagement/Calibration/index.vue"),
  },
  {
    path: "/shutdown-pump",
    name: "shutdown-pump",
    meta: {
      title: "Shutdown Pump",
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/PriceManagement/ShutdownPump/index.vue"),
  },
  {
    path: "/price-change-status",
    name: "price-change-status",
    meta: {
      title: "Price Change Status",
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/PriceManagement/PriceStatus/Index.vue"),
  },
  //staff management
  {
    path: "/staff-management",
    name: "staff-management",
    meta: {
      title: "Staff Management",
      middleware: "auth",
    },
    component: () => import("@/views/Company/StaffManagement/index.vue"),
  },
  {
    path: "/company-staff-list",
    name: "company-staff-list",
    meta: {
      title: "Company Staff",
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/StaffManagement/CompanyStaff/index.vue"),
  },
  {
    path: "/leave-management",
    name: "leave-management",
    meta: {
      title: "Leave Management",
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/StaffManagement/LeaveManagement/index.vue"),
  },
  {
    path: "/salary-management",
    name: "salary-management",
    meta: {
      title: "Salary Management",
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/StaffManagement/SalaryManagement/index.vue"),
  },
  {
    path: "/payroll",
    name: "payroll",
    meta: {
      title: "Payroll",
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/StaffManagement/Payroll/index.vue"),
  },
  {
    path: "/performance-evaluation",
    name: "performance-evaluation",
    meta: {
      title: "Performance Evaluation",
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/StaffManagement/PerformanceEval/index.vue"),
  },
  {
    path: "/staff-comparison",
    name: "staff-comparison",
    meta: {
      title: "Staff Comparison",
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/StaffManagement/PerformanceComparison/index.vue"),
  },
  {
    path: "/leave-details/:staffId",
    name: "leave-details",
    meta: {
      title: "Leave Details",
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/StaffManagement/Drawers/LeaveDetails.vue"),
  },
  // Groups
  {
    path: "/groups",
    name: "groups",
    meta: {
      title: "Groups",
      middleware: "auth",
    },
    component: () => import("@/views/Company/Groups/index.vue"),
  },
  {
    path: "/group/:id",
    name: "single-group",
    meta: {
      title: "Group Details",
      middleware: "auth",
    },
    component: () => import("@/views/Company/Groups/SingleGroup.vue"),
  },
  {
    path: "/group-detail/:id",
    name: "group-detail",
    meta: {
      title: "Group Information",
      middleware: "auth",
    },
    component: () => import("@/views/Company/Groups/Details/index.vue"),
  },
  {
    path: "/group-users/:id",
    name: "group-users",
    meta: {
      title: "Group Users",
      middleware: "auth",
    },
    component: () => import("@/views/Company/Groups/Users/index.vue"),
  },

  // BANKS
  {
    path: "/bank-accounts",
    name: "bank-accounts",
    meta: {
      title: "Bank Accounts",
      middleware: "auth",
    },
    component: () => import("@/views/Common/Bank/BankAccounts/index.vue"),
  },
  {
    path: "/bank-account-requests",
    name: "bank-account-requests",
    meta: {
      title: "Bank Account Requests",
      middleware: "auth",
    },
    component: () =>
      import("@/views/Common/Bank/BankAccountRequests/index.vue"),
  },

  //BANK DEPOSIT
  {
    path: "/bank-deposit",
    name: "bank-deposit",
    meta: {
      title: "Bank Deposits",
      middleware: "auth",
    },
    component: () => import("@/views/Common/BankDeposit/index.vue"),
  },
  {
    path: "/branch-bank-deposit",
    name: "bank-deposit-detail",
    meta: {
      title: "Deposit Details",
      middleware: "auth",
    },
    component: () => import("@/views/Common/BankDeposit/details.vue"),
  },

  // REMIS
  {
    path: "/remis/loyalty",
    name: "remis-loyalty",
    meta: {
      title: "REMIS Loyalty",
      middleware: "auth",
    },
    component: () => import("@/views/Company/Remis/Loyalty/index.vue"),
  },
  {
    path: "/remis/loyalty-detail/:loyaltyId",
    name: "loyalty-details",
    meta: {
      title: "Loyalty Details",
      middleware: "auth",
    },
    component: () => import("@/views/Company/Remis/Loyalty/LoyaltyDetails.vue"),
  },
  {
    path: "/remis/pos",
    name: "remis-pos",
    meta: {
      title: "REMIS POS",
      middleware: "auth",
    },
    component: () => import("@/views/Company/Remis/POS/index.vue"),
  },
  {
    path: "/remis/pos-transaction/:terminalId",
    name: "remis-pos-transaction",
    meta: {
      title: "POS Transactions",
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/Remis/POS/POSTransactionDetails.vue"),
  },
  {
    path: "/remis/fueling",
    name: "remis-fueling",
    meta: {
      title: "REMIS Fueling",
      middleware: "auth",
    },
    component: () => import("@/views/Company/Remis/Fueling/index.vue"),
  },

  {
    path: "/remis/fueling-details",
    name: "remis-fueling-details",
    meta: {
      title: "REMIS Fueling Details",
      middleware: "auth",
    },
    component: () => import("@/views/Company/Remis/Fueling/details.vue"),
  },
  {
    path: "/remis/retainership",
    name: "remis-retainership",
    meta: {
      title: "REMIS Retainership",
      middleware: "auth",
    },
    component: () => import("@/views/Company/Remis/Retainership/index.vue"),
  },
  {
    path: "/remis/wallet-topup-requests",
    name: "wallet-topup-requests",
    meta: {
      title: "Wallet Top-up Requests",
      middleware: "auth",
    },
    component: () => import("@/views/Company/Remis/Wallet-topup/index.vue"),
  },
  {
    path: "/remis/card-management",
    name: "remis-card-management",
    meta: {
      title: "REMIS Card Management",
      middleware: "auth",
    },
    component: () => import("@/views/Company/Remis/CardManagement/index.vue"),
  },
  {
    path: "/remis/retainership/transaction-history",
    name: "remis-retainership-transaction-history",
    meta: {
      title: "Retainership Transaction History",
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/Remis/Retainership/TransactionHistory/index.vue"),
  },
  {
    path: "/remis/wallet",
    name: "remis-wallet",
    meta: {
      title: "REMIS Wallet",
      middleware: "auth",
    },
    component: () => import("@/views/Company/Remis/Wallet/index.vue"),
  },

  /////////////////// STATION RENTS
  {
    path: "/rent-records",
    name: "rent-records",
    meta: {
      title: "Rent Records",
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/StationRents/RentRecords/index.vue"),
  },
  {
    path: "/properties",
    name: "properties",
    meta: {
      title: "Properties",
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/StationRents/Properties/index.vue"),
  },
  {
    path: "/due-properties",
    name: "due-properties",
    meta: {
      title: "Due-Payments",
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/StationRents/Properties/DueProperties.vue"),
  },
  {
    path: "/property-details/:id",
    name: "property-details",
    meta: {
      title: "Property Details",
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/StationRents/Properties/PropertyDetails.vue"),
  },
  {
    path: "/occupants",
    name: "Occupants",
    meta: {
      title: "Occupants",
      middleware: "auth",
    },
    component: () => import("@/views/Company/StationRents/Occupants/index.vue"),
  },
  {
    path: "/occupant-details/:id",
    name: "occupant-details",
    meta: {
      title: "Occupant Details",
      middleware: "auth",
    },
    component: () =>
      import("@/views/Company/StationRents/Occupants/OccupantDetails.vue"),
  },

  // Expense Management
  {
    path: "/Expense-management",
    name: "Expense Management",
    meta: {
      title: "Expense Management",
      middleware: "auth",
      isEntityDependent: true,
      companyComponent: () => import("@/views/Company/Expense/index.vue"),
      branchComponent: () =>
        import("@/views/Company/Expense/ExpenseDetails.vue"),
    },
  },
  {
    path: "/Expense-category",
    name: "Expense Category",
    meta: {
      title: "Expense Categories",
      middleware: "auth",
      isEntityDependent: true,
      companyComponent: () =>
        import("@/views/Company/Expense/ExpenseCategory.vue"),
      branchComponent: () =>
        import("@/views/Company/Expense/ExpenseCategory.vue"),
    },
  },
  {
    path: "/Expense-details/:id",
    name: "Expense Details",
    meta: {
      title: "Expense Details",
      middleware: "auth",
    },
    component: () => import("@/views/Company/Expense/ExpenseDetails.vue"),
  },

  //////////////////// Region Level
  {
    path: "/region/dashboard",
    name: "region-dashboard",
    meta: {
      title: "Region Dashboard",
      middleware: "auth",
    },
    component: () => import("@/views/Common/Dashboard/index.vue"),
  },
  {
    name: "maintenance",
    path: "/maintenance",
    meta: {
      title: "Maintenance",
      middleware: "auth",
      // isEntityDependent: true,
      // companyComponent: () => import("@/views/Common/Maintenance/index.vue"),
      // branchComponent: () => import("@/views/Common/Maintenance/index.vue"),
    },
    component: () => import("@/views/Common/Maintenance/index.vue"),
  },
  {
    name: "maintenance-details",
    path: "/maintenance/:id",
    meta: {
      title: "Maintenance Details",
      middleware: "auth",
      // isEntityDependent: true,
      // companyComponent: () => import("@/views/Common/Maintenance/details.vue"),
      // branchComponent: () => import("@/views/Common/Maintenance/details.vue"),
    },
    component: () => import("@/views/Common/Maintenance/details.vue"),
  },
  {
    name: "assets",
    path: "/assets",
    meta: {
      title: "Assets",
      middleware: "auth",
    },
    component: () => import("@/views/Common/Assets/index.vue"),
  },

  {
    name: "asset-upload-history",
    path: "/asset-upload-history",
    meta: {
      title: "Asset Upload History",
      middleware: "auth",
    },
    component: () => import("@/views/Common/Assets/AssetUploadHistory.vue"),
  },
  {
    name: "category-asset",
    path: "/category-asset",
    meta: {
      title: "Category Assets",
      middleware: "auth",
    },
    component: () => import("@/views/Common/Assets/categoryAsset.vue"),
  },
  {
    name: "station-asset",
    path: "/station-asset",
    meta: {
      title: "Station Assets",
      middleware: "auth",
    },
    component: () => import("@/views/Common/Assets/stationAsset.vue"),
  },
  {
    name: "asset-details",
    path: "/asset-details",
    meta: {
      title: "Asset Details",
      middleware: "auth",
    },
    component: () => import("@/views/Common/Assets/details.vue"),
  },
  // 🚨 VENDOR MGT
  {
    name: "vendor-mgt",
    path: "/vendor-mgt",
    meta: {
      title: "Vendor Management",
      middleware: "auth",
      isEntityDependent: true,
      companyComponent: () => import("@/views/Common/VendorMgt/index.vue"),
      branchComponent: () => import("@/views/Common/VendorMgt/index.vue"),
    },
  },

  {
    name: "vendor-details",
    path: "/vendor-details",
    meta: {
      title: "Vendor Details",
      middleware: "auth",
    },
    component: () => import("@/views/Common/VendorMgt/vendorDetails.vue"),
  },

  ////////////////// Station Level
  {
    path: "/station/dashboard",
    name: "station-dashboard",
    meta: {
      title: "Station Dashboard",
      middleware: "auth",
    },
    component: () => import("@/views/Common/Dashboard/index.vue"),
  },

  // Tank Management
  {
    path: "/tank-management",
    name: "tank-management",
    meta: {
      title: "Tank Management",
      middleware: "auth",
      isEntityDependent: true,
      branchComponent: () => import("@/views/Company/TankManagement/index.vue"),
    },
  },
  {
    path: "/tank-management/:id",
    name: "tank-details",
    meta: {
      title: "Tank Details",
      middleware: "auth",
    },
    component: () => import("@/views/Company/TankManagement/details.vue"),
  },

  // MANUAL RECORDS
  {
    path: "/manual-records",
    name: "manual-records",
    meta: {
      title: "Manual Records",
      middleware: "auth",
    },
    component: () =>
      import("@/views/Common/Manualrecords/ManualRecord/index.vue"),
  },
  {
    path: "/rejected-records",
    name: "rejected-records",
    meta: {
      title: "Rejected Records",
      middleware: "auth",
    },
    component: () =>
      import("@/views/Common/Manualrecords/RejectedRecords/index.vue"),
  },
  {
    path: "/record-dippings",
    name: "record-dippings",
    meta: {
      title: "Record Dippings",
      middleware: "auth",
    },
    component: () =>
      import("@/views/Common/Manualrecords/RecordDipping/index.vue"),
  },
  {
    path: "/manual-record-list",
    name: "manual-record-list",
    meta: {
      title: "Manual Record List",
      middleware: "auth",
    },
    component: () =>
      import("@/views/Common/Manualrecords/RecordList/index.vue"),
  },

  // Support
  {
    name: "support",
    path: "/support",
    meta: {
      title: "Support",
      middleware: "auth",
      isEntityDependent: true,
      companyComponent: () => import("@/views/Common/Support/index.vue"),
      branchComponent: () => import("@/views/Common/Support/index.vue"),
    },
  },
  {
    name: "services",
    path: "/services",
    meta: {
      title: "Services",
      middleware: "auth",
      isEntityDependent: true,
      companyComponent: () => import("@/views/Company/Services/index.vue"),
      branchComponent: () => import("@/views/Branch/Services/index.vue"),
    },
  },
  {
    name: "services-transactions",
    path: "/services-transactions",
    meta: {
      title: "Service Transactions",
      middleware: "auth",
    },
    component: () => import("@/views/Company/Services/manageTransactions.vue"),
  },
  {
    name: "services-transaction",
    path: "/services-transaction/:id",
    meta: {
      title: "Service Transaction Details",
      middleware: "auth",
    },
    component: () => import("@/views/Company/Services/serviceTransactions.vue"),
  },
  {
    name: "services-manage-transactions",
    path: "/services-manage-transactions",
    meta: {
      title: "Manage Service Transactions",
      middleware: "auth",
    },
    component: () => import("@/views/Branch/Services/manageTransactions.vue"),
  },

  // User Management
  {
    path: "/user-management",
    name: "user-management",
    meta: {
      title: "User Management",
      middleware: "auth",
    },
    component: () => import("@/views/Common/UserManagement/index.vue"),
  },
  {
    path: "/user-management/:id",
    name: "single-user",
    meta: {
      title: "User Details",
      middleware: "auth",
    },
    component: () => import("@/views/Common/UserManagement/SingleUser.vue"),
  },

  // INVOICE
  {
    path: "/invoice",
    name: "invoice",
    meta: {
      title: "Invoices",
      middleware: "auth",
    },
    component: () => import("@/views/Common/Invoice/index.vue"),
  },
  {
    path: "/invoice-details/:id",
    name: "invoice-details",
    meta: {
      title: "Invoice Details",
      middleware: "auth",
    },
    component: () => import("@/views/Common/Invoice/details.vue"),
  },
  {
    path: "/invoice-payment-history/:id",
    name: "invoice-payment-history",
    meta: {
      title: "Payment History",
      middleware: "auth",
    },
    component: () => import("@/views/Common/Invoice/paymentHistory.vue"),
  },

  // PAYMENTS
  {
    path: "/stripe-payment",
    name: "makeStripePayment",
    meta: {
      title: "Stripe Payment",
      middleware: "auth",
    },
    component: () =>
      import("@/views/Common/WalletAndPayments/MakeStripePayment.vue"),
  },
  {
    path: "/paystack-payment",
    name: "makePaystackPayment",
    meta: {
      title: "Paystack Payment",
      middleware: "auth",
    },
    component: () =>
      import("@/views/Common/WalletAndPayments/MakePaystackPayment.vue"),
  },

  // PUMP CODE
  {
    path: "/pump-code",
    name: "pumpCode",
    meta: {
      title: "Pump Codes",
      middleware: "auth",
    },
    component: () => import("@/views/Common/PumpCode/index.vue"),
  },

  // ALERT AND ALARM
  {
    path: "/alert-alarm",
    name: "alertAlarm",
    meta: {
      title: "Alerts & Alarms",
      middleware: "auth",
    },
    component: () => import("@/views/Company/AlertAlarm/index.vue"),
  },

  // SUPPORT ADMIN
  {
    path: "/company-list",
    name: "company-list",
    meta: {
      title: "Company List",
      middleware: "auth",
      isSupportAdmin: true,
    },
    component: () => import("@/views/Support/Companies/index.vue"),
  },
  {
    path: "/company-support-tickets",
    name: "company-support-tickets",
    meta: {
      title: "Support Tickets",
      middleware: "auth",
      isSupportAdmin: true,
    },
    component: () => import("@/views/Support/Support/index.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

const preservedQueryParams = ["branchId", "regionId", "groupId", "companyId"];
const noQueryRoutes = ["login", "company-list"];

//route guards
router.afterEach((to) => {
  if (window.gtag) {
    window.gtag("config", "G-YR0P2LW6DX", {
      page_path: to.fullPath,
    });
  }

  // 🚨 Tawk.to chat implementation
  if (window.Tawk_API) {
    if (to.name === "login") {
      window.Tawk_API.hideWidget();
    } else {
      window.Tawk_API.showWidget();
    }
  }
});
router.beforeEach((to, from, next) => {
  document.title = to.meta.title ? `${to.meta.title} :: EPUMP` : "Epump";

  const isAuthenticated = !!localStorage.getItem("auth-user");

  // 🚨 ROUTE GUARD FOR ROUTES THAT CONSIDER USER ROLES 🚨
  if (isAuthenticated) {
    const userRoles = JSON.parse(localStorage.getItem("auth-user")).role || [];
    let shouldProceed = true;
    let redirectPath = null;

    // Find the matching route from your configuration
    const findRouteConfig = (path, configRoutes) => {
      for (const route of configRoutes) {
        // Check main route
        if (route.path === path || route.name?.includes(to.name)) {
          return route;
        }
        // Check nested routes
        if (route.children) {
          const childMatch = route.children.find(
            (child) => child.path === path || child.name === to.name,
          );
          if (childMatch) {
            return { ...childMatch, parentRoles: route.roles };
          }
        }
      }
      return null;
    };

    const routeConfig =
      findRouteConfig(to.path, routesConfig.routes) ||
      findRouteConfig(to.path, routesConfig.otherRoutes);

    // Support admin bypass (can access all routes)
    if (!userRoles.includes("SupportAdmin")) {
      // If route requires specific roles
      if (routeConfig?.roles || routeConfig?.parentRoles) {
        // Combine route roles and parent route roles if they exist
        const requiredRoles = [
          ...(routeConfig.roles || []),
          ...(routeConfig.parentRoles || []),
        ];

        // Check if user has at least one required role
        const hasAccess =
          requiredRoles.length === 0 ||
          requiredRoles.some((role) => userRoles.includes(role));

        if (!hasAccess) {
          shouldProceed = false;
          redirectPath = from.name ? from : { name: "dashboard" };
          setTimeout(() => {
            errorToast(translateText("common.noPageAccess"));
          }, 3000);
        }
      }
    }

    if (!shouldProceed) {
      return next(redirectPath);
    }
  }

  // 🚨 If route requires authentication and user is not authenticated
  if (to.meta.middleware === "auth" && !isAuthenticated) {
    return next("/login"); // Redirect to login page
  }

  // 🚨 If user is authenticated but trying to access a non-auth route
  if (
    to.meta.middleware !== "auth" &&
    from.meta?.middleware === "auth" &&
    isAuthenticated
  ) {
    return next(false); // prevent from accessing the route
  }
  if (to.meta.middleware !== "auth" && isAuthenticated) {
    return next("/dashboard"); // Prevent or redirect to dashboard
  }

  // 🚨 ROUTE GUARD FOR UNKNOWN ROUTES
  const matchedRouteExists = to.matched.length > 0;
  if (!isAuthenticated && !matchedRouteExists) {
    return next("/login");
  }

  // 🚨 ROUTE GUARD FOR ROUTES, QUERY AND PARAMS
  let updatedQuery;

  if (noQueryRoutes.includes(lowerCase(to.name))) {
    updatedQuery = {}; // Reset query params for login page
  } else {
    if (to.query.new) {
      updatedQuery = { ...to.query };
    } else {
      updatedQuery = { ...to.query };

      preservedQueryParams.forEach((param) => {
        if (from.query[param]) {
          updatedQuery[param] = from.query[param];
        }
      });
    }
  }

  const { entityType } = getEntityQuery(updatedQuery);

  // Handle entity-dependent components
  to.matched.forEach((routeRecord) => {
    if (routeRecord.meta.isEntityDependent) {
      if (!routeRecord.components) {
        routeRecord.components = {}; // Initialize components if undefined
      }

      // Safely assign default component based on entity
      if (entityType?.toLowerCase() === "branch") {
        routeRecord.components.default = routeRecord.meta.branchComponent;
      } else {
        routeRecord.components.default = routeRecord.meta.companyComponent;
      }
    }
  });

  // If query params have been updated, navigate to the new query path
  if (JSON.stringify(to.query) !== JSON.stringify(updatedQuery)) {
    return next({
      path: to.path,
      query: updatedQuery,
      // replace: true,
    });
  }

  // 🚨 Redirect support admin to the company list whenever they visit a page without a query parameter

  if (
    isAuthenticated &&
    doesUserRoleHave("SupportAdmin") &&
    Object.keys(updatedQuery)?.length < 1 &&
    to.name !== "company-list" &&
    to.name !== "company-support-tickets"
  ) {
    return next({
      path: "/company-list",
      query: updatedQuery,
    });
  }

  // REVISIT COMPANY STAFF
  // console.log(to.query, from.query, "to.query");
  if (to.name === "company-staff-list" && to.query?.branchId) {
    // console.log("Removing branchId to prevent loop...");

    const { branchId, ...queryWithoutBranchId } = to.query;
    // console.log(queryWithoutBranchId, "query");
    to.query = queryWithoutBranchId;

    return next();
  }

  //

  // Scroll to the top on route change
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "smooth",
  });

  // If no updates are required, continue with navigation
  return next();
});

export default router;
